<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="container admin-dashboard-parent refcodes-container copy-editor-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>Admin <i class="fa fas fa-chevron-right"></i></span>
                <app-breadcrumb [pageName]="'Refcodes'" [isTopLevel]="true"></app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>RefCodes</h1>
                <input type="submit" value="Add New" (click)="addNew()">
            </div>
        </section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
        <section class="all-users-data">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-borderless table-hover">
                    <thead>
                        <tr>
                            <th scope="col">RefCodes</th>
                            <th scope="col">User type that'll be created</th>
                            <th scope="col">Funded</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of list; let i = index;">
                            <tr class="body-header" (click)="toggleSection(item.code)">
                                <td>{{item.code}}</td>
                                <td>{{item.instructions.userType}}</td>
                                <td>{{item.instructions.funded}}</td>
                            </tr>
                            <tr class="body-body" [ngClass]="{'hide':selectedItemCode!=item.code,'expanded':selectedItemCode === item.code}">
                                <td colspan="3">
                                    <section class="body-container">
                                        <label>
                                            <span class="label">Code</span>
                                            <input type="text" [(ngModel)]="item.code" readonly>
                                        </label>
                                        <label>
                                            <span class="label">Plan</span>
                                            <input type="text" [(ngModel)]="item.chargebee_plan">
                                        </label>
                                        <label>
                                            <span class="label">Addon</span>
                                            <input type="text" [(ngModel)]="item.chargebee_addon">
                                        </label>
                                        <label>
                                            <span class="label">Base license count</span>
                                            <input type="text" [(ngModel)]="item.chargebee_base">
                                        </label>

                                    </section>
                                    <label>
                                        <span class="label">UserType</span>
                                        <input type="text" [(ngModel)]="item.instructions.userType">
                                    </label><br>
                                    <label class="checkbox-label">
                                        <span class="label">Funded</span>
                                        <input type="checkbox" [(ngModel)]="item.instructions.funded" [checked]="checked" [disabled]="disabled">
                                    </label><br>
                                    <label class="checkbox-label">
                                        <span class="label">Hide Sponsor</span>
                                        <input type="checkbox" [(ngModel)]="item.instructions.hideSponsor">
                                    </label><br>
                                  <label class="checkbox-label">
                                    <span class="label">Direct Invoice</span>
                                    <input type="checkbox" [(ngModel)]="item.instructions.directInvoice" (change)="checkIfDirectInvoice(item.instructions.directInvoice)">
                                  </label><br>
                                  <label class="checkbox-label">
                                    <span class="label">NFZ</span>
                                    <input type="checkbox" [disabled]="this.isDisabled" [(ngModel)]="item.instructions.nfz">
                                  </label><br>

                                    <input type="submit" value="Save" (click)="saveItem(item)">
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="pagination-controls-container">
                <app-pagination [currentPage]="page" [totalPages]="totalPages"
                    (pageChange)="loadUsers($event)"></app-pagination>
            </div>
        </section>
    </section>
</section>
